const reviewDummy = [
  {
    id: 1,
    nickname: 'test1',
    date: '2023.12.07',
    review: '좋은 거래 감사합니다.',
  },
  {
    id: 2,
    nickname: 'test2',
    date: '2023.10.08',
    review: '작품 너무 예쁘고 완충도 잘 해주십니다!',
  },
  {
    id: 3,
    nickname: 'test3',
    date: '2023.12.09',
    review: '채팅 답장 조금만 빨리 해주셨으면 좋겠어요ㅜㅜ 작품은 예쁩니다.',
  },
  {
    id: 4,
    nickname: 'test4',
    date: '2023.08.10',
    review:
      '작품이 많이 손상돼서 왔어요. 기대보다 별로였습니다.. 사진상 그림은 정말 마음에 들었는데, 직접 받아보니 변색도 많이 됐고 아쉽네요 정말',
  },
  {
    id: 5,
    nickname: 'test5',
    date: '2023.12.11',
    review: '좋은 거래 감사합니다.',
  },
  {
    id: 6,
    nickname: 'test6',
    date: '2023.05.12',
    review: '작품 너무 예쁘고 완충도 잘 해주십니다!',
  },
  {
    id: 7,
    nickname: 'test7',
    date: '2023.12.13',
    review: '채팅 답장 조금만 빨리 해주셨으면 좋겠어요ㅜㅜ 작품은 예쁩니다.',
  },
  {
    id: 8,
    nickname: 'test8',
    date: '2023.12.14',
    review: '마음에 쏙 드는 작품입니다! 앞으로도 많이 구매하고 싶어요.',
  },
  {
    id: 9,
    nickname: 'test9',
    date: '2023.03.15',
    review: '채팅 답장 조금만 빨리 해주셨으면 좋겠어요ㅜㅜ 작품은 예쁩니다.',
  },
  {
    id: 10,
    nickname: 'test10',
    date: '2023.12.16',
    review: '좋은 거래 감사합니다.',
  },
  {
    id: 11,
    nickname: 'test11',
    date: '2023.11.17',
    review: '작품 너무 예쁘고 완충도 잘 해주십니다!',
  },
];

export default reviewDummy;
